// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge-module_badgeContainer__RpJxY {
    display: inline-block;
    border-radius: 50%;
    background: var(--white);
    border: 2px solid var(--white);
    width: 20px;
    height: 20px;
    box-sizing: border-box;
}

.badge-module_medium__HIqZK {
    width: 24px;
    height: 24px;
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/UI/Badge/badge.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".badgeContainer {\n    display: inline-block;\n    border-radius: 50%;\n    background: var(--white);\n    border: 2px solid var(--white);\n    width: 20px;\n    height: 20px;\n    box-sizing: border-box;\n}\n\n.medium {\n    width: 24px;\n    height: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badgeContainer": `badge-module_badgeContainer__RpJxY`,
	"medium": `badge-module_medium__HIqZK`
};
export default ___CSS_LOADER_EXPORT___;
